module.exports = __webpack_public_path__ + "img/img-65e95f.jpg";